import(/* webpackMode: "eager" */ "/root/tekyerde-frontend/app/(commerce)/albumler/page.tsx");
